import SEO from "@/components/SEO";
import { useSiteSettings } from "@/lib/siteSettings";
import MembershipHero from "./components/MembershipHero";
import MembershipTypes from "./components/MembershipTypes";
import MembershipBenefits from "./components/MembershipBenefits";
import MembershipDirectory from "./components/MembershipDirectory";
import MembershipApplicationForm from "./components/MembershipApplicationForm";
import MembershipInvite from "./components/MembershipInvite";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const DESCRIPTION = "TAIAA 會員類型與會費、會員專屬權益、會員名錄與入會方式一次看。個人、團體與企業會員方案，與台灣 AI 生態系共同成長。";

const membershipSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "會員專區｜TAIAA 台灣 AI 應用推廣協會",
  description: DESCRIPTION,
  url: siteUrl ? `${siteUrl}/membership` : undefined,
};

export default function Membership() {
  const { settings } = useSiteSettings();
  // 邀請制（預設）時不顯示線上申請表，改為說明入會方式；可在後台「網站設定 → 會員制度與會費」開放。
  const applicationsOpen = settings.membership.applications_open;

  return (
    <main className="pt-0">
      <SEO
        title="會員專區｜TAIAA 台灣 AI 應用推廣協會"
        description={DESCRIPTION}
        keywords="TAIAA,會員專區,會員權益,入會方式,AI 會員,會員類型"
        schema={membershipSchema}
      />
      <MembershipHero />
      <MembershipTypes />
      <MembershipBenefits />
      <MembershipDirectory />
      {applicationsOpen ? <MembershipApplicationForm /> : <MembershipInvite />}
    </main>
  );
}
